import "./Style.scss";
import PropTypes from "prop-types";
import OtpInput from "react-otp-input";
import {
  update2FAType,
  sendSms2FA,
  checkSms2FA,
  sendOtp2FA,
  checkOtp2FA,
} from "api/api_register2FA";
import { useState, React, useEffect } from "react";
import Swal from "sweetalert2";
import { Box } from "@mui/material";
import { clearLocalStorage } from "utils/storage";
import Register2FAScanQR from "./Register2FAScanQR";
import Register2FAPatternLock from "./Register2FAPatternLock";
import Register2FAFace from "./Register2FAFace";
import Register2FAVoice from "./Register2FAVoice";
import Register2FAFinger from "./Register2FAFinger";
import Register2FAIris from "./Register2FAIris";

function Register2FACheckOTPFirst({ type }) {
  const [otp, setOTP] = useState("");
  const [count, setCount] = useState(120);
  const user = JSON.parse(localStorage.getItem("user"));

  const handleSendAgain = async () => {
    setCount(120);
    if (type === "email") {
      await sendOtp2FA(user.username);
    } else {
      await sendSms2FA(user.username);
    }
  };

  const update2FA = async (typeFA) => {
    await update2FAType(user.username, typeFA);
  };

  useEffect(() => {
    (async () => {
      if (type === "email") {
        await sendOtp2FA(user.username);
      } else if (type === "sms") {
        await sendSms2FA(user.username);
      }
    })();
  }, []);

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      // Decrease count by 1
      setCount((prevCount) => prevCount - 1);
    }, 1000);
    // Clear interval and stop countdown when count reaches 0
    if (count === 0) {
      clearInterval(countdownInterval);
    }
    // Cleanup the interval on component unmount
    return () => clearInterval(countdownInterval);
  }, [count]);

  const handle = async () => {
    const data =
      type === "email"
        ? await checkOtp2FA(user.username, otp, user.email)
        : await checkSms2FA(user.username, user.phone, otp);
    if (data) {
      update2FA(type === "email" ? 1 : 2);
      Swal.fire({
        title: "Xác minh 2 bước đã được bật",
        icon: "success",
      });
      setTimeout(() => {
        clearLocalStorage();
        window.location.href = "/authentication/sign-in";
      }, 1500);
    } else {
      Swal.fire({
        title: "Xác minh 2 bước thất bại",
        icon: "error",
      });
    }
  };

  return (
    <>
      {(type === "sms" || type === "email") && (
        <Box
          width={460}
          height={480}
          className="form-container"
          sx={{ padding: "80px 60px 80px 60px" }}
        >
          <Box className="fs-20 fw-700">Xác thực qua {type === "sms" ? "SMS" : "Email"}</Box>
          <Box>
            <Box className="fs-14 gray-80 txt-align">
              Nhập mã OTP đã gửi đến
              {type === "email"
                ? ` ${user.email.replace(/^(.{3}).*?(@.*)$/, "$1***$2")}`
                : ` ${user.phone.replace(/(\d{3})\d{4}(\d{3})/, "$1****$2")}`}
            </Box>
            <Box className="fs-14 centered">
              Mã OTP sẽ hết hạn trong&nbsp; <span style={{ color: "#FF3C3C" }}> {count} </span>
              &nbsp;giây
            </Box>
          </Box>
          <Box className="w-100">
            <Box className="fs-14">Mã OTP</Box>
            <OtpInput
              onChange={(e) => setOTP(e)}
              value={otp}
              numInputs={6}
              separator={<span> </span>}
              isInputNum
              shouldAutoFocus
              inputStyle="inputStyle1"
              containerStyle="containOTP1"
            />
          </Box>
          <Box className="fs-14">
            Không nhận được mã OTP?{" "}
            <span
              style={{ color: "var(--blue-blue-100)", cursor: "pointer" }}
              onClick={handleSendAgain}
              role="button"
              onKeyDown={() => {}}
              tabIndex={0}
            >
              Gửi lại mã
            </span>
          </Box>
          <Box
            className="centered fs-14"
            style={{
              width: "40%",
              height: "36px",
              background: count === 0 ? "#657075" : "var(--blue-blue-100)",
              borderRadius: "6px",
              color: "white",
              cursor: "pointer",
            }}
            role="button"
            tabIndex="0"
            onClick={count !== 0 ? handle : () => {}}
            onKeyDown={() => {}}
          >
            Xác nhận
          </Box>
        </Box>
      )}
      {(type === "GGA" || type === "MCA") && (
        <Register2FAScanQR authenType={{ authenTypeName: type }} />
      )}
      {type === "fingerprint" && <Register2FAFinger />}
      {type === "pattern" && <Register2FAPatternLock />}
      {type === "face" && <Register2FAFace />}
      {type === "voice" && <Register2FAVoice />}
      {type === "iris" && <Register2FAIris />}
    </>
  );
}

Register2FACheckOTPFirst.propTypes = {
  type: PropTypes.string.isRequired,
};

export default Register2FACheckOTPFirst;
